var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#47464A",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M7.155 13.624l7.784-7.784a1 1 0 0 1 1.414 0l1.9 1.9a1 1 0 0 1 0 1.415l-7.783 7.784a1 1 0 0 1-.654.291l-2.564.137a.5.5 0 0 1-.526-.526l.138-2.563a1 1 0 0 1 .291-.654z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.34 7.44l3.314 3.314"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlack);
export default __webpack_public_path__ + "static/media/edit_black.7ba36d4c7f880bd957b3588938bc621f.svg";
export { ForwardRef as ReactComponent };